interface JwtPayload {
  [key: string]: any;
  SecurityContactCultureId?: string;
}

/**
 * Decodes a JWT token and returns the payload
 * Note: This only decodes the payload, it doesn't verify the signature
 */
export function decodeJwtToken(token: string): JwtPayload | null {
  try {
    // JWT tokens have 3 parts separated by dots: header.payload.signature
    const parts = token.split('.');
    if (parts.length !== 3) {
      console.warn('Invalid JWT token format');
      return null;
    }

    // Decode the payload (second part)
    const payload = parts[1];
    // Add padding if needed for base64 decoding
    const paddedPayload = payload + '='.repeat((4 - payload.length % 4) % 4);
    const decodedPayload = atob(paddedPayload.replace(/-/g, '+').replace(/_/g, '/'));
    
    return JSON.parse(decodedPayload);
  } catch (error) {
    console.error('Error decoding JWT token:', error);
    return null;
  }
}

/**
 * Extracts the language from a JWT token based on SecurityContactCultureId
 * @param token JWT token string
 * @returns 'en' for SecurityContactCultureId '48', 'fr' for '88', 'en' as default
 */
export function getLanguageFromToken(token: string): 'en' | 'fr' {
  const payload = decodeJwtToken(token);
  if (!payload) {
    console.warn('Could not decode JWT token, defaulting to English');
    return 'en';
  }

  const cultureId = payload.SecurityContactCultureId;
  if (!cultureId) {
    console.warn('SecurityContactCultureId not found in token, defaulting to English');
    return 'en';
  }

  switch (cultureId) {
    case '48':
      return 'en';
    case '88':
      return 'fr';
    default:
      console.warn(`Unknown SecurityContactCultureId: ${cultureId}, defaulting to English`);
      return 'en';
  }
} 